"use client";

import { forwardRef, useId } from "react";
import { cn } from "@/utils";

export interface CheckboxProps extends Omit<React.ComponentPropsWithRef<"input">, "onChange"> {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  description?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { id, checked, onChange, label, description, disabled = false, className, ...props },
  ref,
) {
  const descriptionId = useId();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };

  return (
    <label
      className={cn(
        "flex items-center gap-2 cursor-pointer",
        disabled && "opacity-50 cursor-not-allowed",
        className,
      )}
    >
      <input
        ref={ref}
        id={id}
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        aria-describedby={description ? descriptionId : undefined}
        className="h-3.5 w-3.5 rounded border-border-primary text-text-primary focus:ring-1 focus:ring-ring-focus focus:ring-offset-0 disabled:cursor-not-allowed"
        {...props}
      />
      {(label || description) && (
        <div className="flex flex-col">
          {label && <span className="text-2xs-plus font-medium text-text-secondary">{label}</span>}
          {description && (
            <span id={descriptionId} className="text-2xs text-text-tertiary">
              {description}
            </span>
          )}
        </div>
      )}
    </label>
  );
});
